var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViewReport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.0002 13.0006L2.0002 3.00064L3.2002 3.00064L3.2002 13.0006L2.0002 13.0006Z",
    fill: "#03AB70"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.0002 13L4.0002 8L5.2002 8L5.2002 13L4.0002 13Z",
    fill: "#03AB70"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 9.99999H7V8.79999H11V9.99999Z",
    fill: "#03AB70"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 13H7V11.8H11V13Z",
    fill: "#03AB70"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.2 1.2V14.8H12.1333V1.2H1.2ZM1 0C0.447715 0 0 0.447715 0 1V15C0 15.5523 0.447714 16 0.999999 16H12.3333C12.8856 16 13.3333 15.5523 13.3333 15V1C13.3333 0.447715 12.8856 0 12.3333 0H1Z",
    fill: "#03AB70"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4 5C4 5.39556 4.1173 5.78224 4.33706 6.11114C4.55682 6.44004 4.86918 6.69638 5.23463 6.84776C5.60009 6.99913 6.00222 7.03874 6.39018 6.96157C6.77814 6.8844 7.13451 6.69392 7.41421 6.41421C7.69392 6.13451 7.8844 5.77814 7.96157 5.39018C8.03874 5.00222 7.99913 4.60009 7.84776 4.23463C7.69638 3.86918 7.44004 3.55682 7.11114 3.33706C6.78224 3.1173 6.39556 3 6 3L6 5L4 5Z",
    fill: "#03AB70"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewReport);
export default __webpack_public_path__ + "static/media/view-report.0624d1f3.svg";
export { ForwardRef as ReactComponent };